import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = { class: "settings-content" };
const _hoisted_3 = { class: "settings-nav" };
const _hoisted_4 = { class: "settings-panel" };
const _hoisted_5 = { class: "settings-section" };
const _hoisted_6 = {
    key: 0,
    class: "profile-info"
};
const _hoisted_7 = { class: "profile-row" };
const _hoisted_8 = { class: "profile-value" };
const _hoisted_9 = { class: "profile-row" };
const _hoisted_10 = { class: "profile-value" };
const _hoisted_11 = {
    key: 0,
    class: "profile-row"
};
const _hoisted_12 = { class: "profile-value" };
const _hoisted_13 = {
    key: 1,
    class: "settings-loading"
};
const _hoisted_14 = { class: "settings-section" };
const _hoisted_15 = {
    key: 0,
    class: "notification-toggles"
};
const _hoisted_16 = { class: "notification-toggle" };
const _hoisted_17 = { class: "notification-toggle" };
const _hoisted_18 = { class: "notification-toggle" };
const _hoisted_19 = {
    key: 1,
    class: "settings-loading"
};
const _hoisted_20 = { class: "settings-section" };
const _hoisted_21 = { class: "colour-mode-options" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "colour-mode-label" };
const _hoisted_24 = {
    key: 1,
    class: "settings-placeholder"
};
const _hoisted_25 = {
    key: 2,
    class: "settings-section"
};
const _hoisted_26 = { class: "notification-toggles" };
const _hoisted_27 = { class: "notification-toggle" };
import { ref, watch } from 'vue';
import MGToggle from '../../components/elements/MGToggle.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SettingsOverlay',
    props: {
        customer: { default: null },
        colourMode: { default: 'dark' },
        safeTop: { default: 0 }
    },
    emits: ["close", "update-pref", "select-colour-mode"],
    setup(__props) {
        const props = __props;
        const activeTab = ref('general');
        const colourModes = [
            { value: 'light', label: 'Light' },
            { value: 'dark', label: 'Dark' }
        ];
        const hideFinancialFigures = ref(localStorage.getItem('randomiseFigures') === 'true');
        watch(hideFinancialFigures, (val) => {
            localStorage.setItem('randomiseFigures', String(val));
            window.dispatchEvent(new CustomEvent('randomise-figures-changed', { detail: val }));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["settings-view", _ctx.colourMode])
            }, [
                _createElementVNode("div", {
                    class: "settings-header",
                    style: _normalizeStyle({ paddingTop: (20 + _ctx.safeTop) + 'px' })
                }, [
                    _createElementVNode("button", {
                        class: "settings-back",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                    }, [
                        _createElementVNode("img", {
                            src: require('@/assets/arrow-left.png'),
                            alt: "Back",
                            class: "back-arrow-icon"
                        }, null, 8, _hoisted_1)
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "settings-title" }, "Settings", -1))
                ], 4),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                            class: _normalizeClass(["settings-nav-item", { active: activeTab.value === 'general' }]),
                            onClick: _cache[1] || (_cache[1] = ($event) => (activeTab.value = 'general'))
                        }, "General", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["settings-nav-item", { active: activeTab.value === 'account' }]),
                            onClick: _cache[2] || (_cache[2] = ($event) => (activeTab.value = 'account'))
                        }, "Account", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["settings-nav-item", { active: activeTab.value === 'privacy' }]),
                            onClick: _cache[3] || (_cache[3] = ($event) => (activeTab.value = 'privacy'))
                        }, "Privacy", 2)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (activeTab.value === 'general')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "settings-section-title" }, "Profile", -1)),
                                    (_ctx.customer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "profile-label" }, "Name", -1)),
                                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.customer.person?.firstName) + " " + _toDisplayString(_ctx.customer.person?.lastName), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_9, [
                                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "profile-label" }, "Email", -1)),
                                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.customer.person?.email), 1)
                                            ]),
                                            (_ctx.customer.person?.mobilePhone)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "profile-label" }, "Phone", -1)),
                                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.customer.person?.mobilePhone), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_13, "Loading profile..."))
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "settings-section-title" }, "Notifications", -1)),
                                    (_ctx.customer?.preferences)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "toggle-info" }, [
                                                    _createElementVNode("span", { class: "toggle-label" }, "Daily current balance"),
                                                    _createElementVNode("span", { class: "toggle-description" }, "Receive your current account balance each morning")
                                                ], -1)),
                                                _createVNode(MGToggle, {
                                                    "model-value": _ctx.customer.preferences.dailyCurrentBalanceNotifications,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_ctx.$emit('update-pref', 'dailyCurrentBalanceNotifications', $event)))
                                                }, null, 8, ["model-value"])
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "toggle-info" }, [
                                                    _createElementVNode("span", { class: "toggle-label" }, "Daily credit balance"),
                                                    _createElementVNode("span", { class: "toggle-description" }, "Receive your credit balance each morning")
                                                ], -1)),
                                                _createVNode(MGToggle, {
                                                    "model-value": _ctx.customer.preferences.dailyCreditBalanceNotifications,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('update-pref', 'dailyCreditBalanceNotifications', $event)))
                                                }, null, 8, ["model-value"])
                                            ]),
                                            _createElementVNode("div", _hoisted_18, [
                                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "toggle-info" }, [
                                                    _createElementVNode("span", { class: "toggle-label" }, "Quiz notifications"),
                                                    _createElementVNode("span", { class: "toggle-description" }, "Get notified about new quizzes")
                                                ], -1)),
                                                _createVNode(MGToggle, {
                                                    "model-value": _ctx.customer.preferences.quizNotifications,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (_ctx.$emit('update-pref', 'quizNotifications', $event)))
                                                }, null, 8, ["model-value"])
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_19, "Loading preferences..."))
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                    _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "settings-section-title" }, "Appearance", -1)),
                                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "settings-label" }, "Colour mode", -1)),
                                    _createElementVNode("div", _hoisted_21, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colourModes, (mode) => {
                                            return _createElementVNode("button", {
                                                key: mode.value,
                                                class: _normalizeClass(["colour-mode-option", { active: _ctx.colourMode === mode.value }]),
                                                onClick: ($event) => (_ctx.$emit('select-colour-mode', mode.value))
                                            }, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["colour-mode-preview", mode.value])
                                                }, _cache[17] || (_cache[17] = [
                                                    _createStaticVNode("<div class=\"preview-sidebar\" data-v-3bc89f4f></div><div class=\"preview-content\" data-v-3bc89f4f><div class=\"preview-line short\" data-v-3bc89f4f></div><div class=\"preview-line\" data-v-3bc89f4f></div><div class=\"preview-input\" data-v-3bc89f4f><div class=\"preview-dot\" data-v-3bc89f4f></div></div></div>", 2)
                                                ]), 2),
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(mode.label), 1)
                                            ], 10, _hoisted_22);
                                        }), 64))
                                    ])
                                ])
                            ], 64))
                            : _createCommentVNode("", true),
                        (activeTab.value === 'account')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[20] || (_cache[20] = [
                                _createElementVNode("p", null, "Account settings coming soon.", -1)
                            ])))
                            : _createCommentVNode("", true),
                        (activeTab.value === 'privacy')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "settings-section-title" }, "Display", -1)),
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "toggle-info" }, [
                                            _createElementVNode("span", { class: "toggle-label" }, "Hide financial figures"),
                                            _createElementVNode("span", { class: "toggle-description" }, "Mask balances and amounts for privacy")
                                        ], -1)),
                                        _createVNode(MGToggle, {
                                            modelValue: hideFinancialFigures.value,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((hideFinancialFigures).value = $event))
                                        }, null, 8, ["modelValue"])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 2));
        };
    }
});
